module.exports = __webpack_public_path__ + "static/img/rocket.9c3201d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rocket.gif
// module id = 5utM
// module chunks = 1